import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { isPromotionLive } from "@/lib/promotion/isPromotionLive";
import { buildPromotionOfferJsonLd, type PromotionHighlightsFields } from "@/lib/promotion-offer-jsonld";
import { JsonLd } from "../JsonLd";
type Props = PromotionHighlightsFields;

// Renders an h2, not an h1: this module can be placed on any page, including
// pages that already carry a pageHeader. Owning the h1 would guarantee a
// duplicate heading on those pages.
export default function PromotionHighlights(props) {
  const $ = _c(20);
  const {
    name,
    description,
    promoCode,
    redemptionUrl
  } = props;
  if (!isPromotionLive(props, new Date())) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("PromotionHighlights hidden: promotion is not live.", {
        name,
        active: props.active,
        availabilityStarts: props.availabilityStarts,
        availabilityEnds: props.availabilityEnds
      });
    }
    return null;
  }
  let t0;
  if ($[0] !== props) {
    t0 = buildPromotionOfferJsonLd(props);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <JsonLd data={t0} />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== name) {
    t2 = <h2 className="heading-xl">{name}</h2>;
    $[4] = name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== description) {
    t3 = <p className="text-xl">{description}</p>;
    $[6] = description;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== promoCode) {
    t4 = <p className="text-lg">Use promo code <code className="font-bold">{promoCode}</code> at checkout</p>;
    $[8] = promoCode;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== redemptionUrl) {
    t5 = <Button asChild={true}><a href={redemptionUrl}>Redeem this offer</a></Button>;
    $[10] = redemptionUrl;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div className="mx-auto flex max-w-2xl flex-col items-center gap-6 text-center">{t2}{t3}{t4}{t5}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t6) {
    t7 = <section className="w-full max-w-site-content mx-auto px-6 py-16">{t1}{t6}</section>;
    $[17] = t1;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}